import { Snackbar as MuiSnackbar } from "@mui/material";
import { useState } from "react";

type Messages = { working: string, done: string }

const statusMessage = (status: string, messages: Messages) => {
  switch (status) {
    case "working":
      return `⏳ ${messages.working}...`;
    case "done":
      return `✅ ${messages.done}`;
    case "error":
      return "❌ Błąd";
    default:
      return "";
  }
}

export const useSnackbar = () => {
  const [snackbarStatus, setSnackbarStatus] = useState<"idle" | "working" | "done" | "error">("idle");

  const Snackbar = ({ messages }: { messages: Messages }) => (
    <MuiSnackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={snackbarStatus !== "idle"}
      autoHideDuration={4000}
      message={statusMessage(snackbarStatus, messages)}
      slotProps={{
        content: {
          style: {
            background: "#1f8038",
            borderRadius: 16
          }
        }
      }}
    />
  )

  return {
    Snackbar,
    snackbarStatus,
    setSnackbarStatus
  }
}
